import { WidgetSizeT } from "../../localTypes/WidgetSizeT";

export function WAWidgetSizeToNoteSize(size: WidgetSizeT) {
  switch (size.h) {
    case 1:
      return "TWO_X_ONE";
    case 2:
      return "TWO_X_TWO";
  }
  throw Error(`Size not available for widget note. ${size}`);
}
